import React from 'react';
import Icon from '../../../components/AppIcon';

const AnalysisCard = ({ summary, confidence, keyFindings, riskAssessment, getRiskColor }) => {
  return (
    <div className="bg-card rounded-lg shadow-sm border border-border p-4 md:p-6">
      <div className="flex items-start justify-between gap-4 mb-4">
        <div className="flex items-center gap-3">
          <div className="w-12 h-12 bg-primary/10 rounded-md flex items-center justify-center">
            <Icon name="BarChart3" size={24} color="var(--color-primary)" />
          </div>
          <div>
            <h2 className="font-heading font-semibold text-xl md:text-2xl text-foreground">
              Analysis Summary
            </h2>
            <p className="caption text-muted-foreground">
              Confidence: {Math.round((confidence || 0) * 100)}%
            </p>
          </div>
        </div>
        {riskAssessment && (
          <div className={`
            px-3 py-1.5 rounded-md flex items-center gap-2
            bg-${getRiskColor(riskAssessment?.overallRisk)}/10
          `}>
            <Icon 
              name="Shield" 
              size={16} 
              color={`var(--color-${getRiskColor(riskAssessment?.overallRisk)})`}
            />
            <span className={`
              font-body font-medium text-sm capitalize
              text-${getRiskColor(riskAssessment?.overallRisk)}
            `}>
              {riskAssessment?.overallRisk} Risk
            </span>
          </div>
        )}
      </div>

      <div className="mb-6">
        <p className="font-body text-base text-foreground leading-relaxed">
          {summary}
        </p>
      </div>

      {keyFindings && keyFindings?.length > 0 && (
        <div className="mb-6">
          <h3 className="font-body font-semibold text-sm text-foreground mb-3 flex items-center gap-2">
            <Icon name="CheckCircle" size={16} color="var(--color-success)" />
            Key Findings
          </h3>
          <ul className="space-y-2">
            {keyFindings?.map((finding, index) => (
              <li key={index} className="flex items-start gap-2">
                <Icon name="ChevronRight" size={16} color="var(--color-primary)" className="mt-0.5 flex-shrink-0" />
                <span className="font-body text-sm text-foreground">{finding}</span>
              </li>
            ))}
          </ul>
        </div>
      )}

      {riskAssessment && (
        <div className="pt-4 border-t border-border">
          <h3 className="font-body font-semibold text-sm text-foreground mb-3 flex items-center gap-2">
            <Icon name="AlertTriangle" size={16} color="var(--color-warning)" />
            Risk Assessment
          </h3>
          <div className="space-y-3">
            {riskAssessment?.riskFactors && riskAssessment?.riskFactors?.length > 0 && (
              <div>
                <p className="caption text-muted-foreground mb-2">Risk Factors:</p>
                <ul className="space-y-1">
                  {riskAssessment?.riskFactors?.map((factor, index) => (
                    <li key={index} className="flex items-start gap-2">
                      <Icon name="Minus" size={14} color="var(--color-muted-foreground)" className="mt-0.5 flex-shrink-0" />
                      <span className="caption text-foreground">{factor}</span>
                    </li>
                  ))}
                </ul>
              </div>
            )}
            {riskAssessment?.mitigationStrategies && riskAssessment?.mitigationStrategies?.length > 0 && (
              <div>
                <p className="caption text-muted-foreground mb-2">Mitigation Strategies:</p>
                <ul className="space-y-1">
                  {riskAssessment?.mitigationStrategies?.map((strategy, index) => (
                    <li key={index} className="flex items-start gap-2">
                      <Icon name="CheckCircle" size={14} color="var(--color-success)" className="mt-0.5 flex-shrink-0" />
                      <span className="caption text-foreground">{strategy}</span>
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default AnalysisCard;
